import type { CloseStatus } from "./close.types";
import type { ICompany } from "./company.types";
import type { IUser } from "./user.types";

export interface PaginatedResponse<T> {
	data: T[];
	count: number;
}

export interface IProject {
	allTasks: number;
	completedTasks: number;
	application: ICompany;
	dueDate: Date;
	startDate: Date;
	status: number;
	type: number;
	id: number;
	name: string;
	users: IUser[];
	company: ICompany;
	createdAt: Date;
	updatedAt: Date;
	/**
	 * Set only on a generated month-end close; null on every plain project.
	 * GET /projects/:id carries it, and it is what makes the Projects pages
	 * treat a close as a close (/qa r9 E-7).
	 */
	closeTemplateId?: string | null;
	/**
	 * The project's type as the API computes it from the close template:
	 * `close` or `project`. Absent from an API that does not send it yet.
	 */
	kind?: "project" | "close" | null;
	/**
	 * A close's five-value status, as the Close Tracker board shows it. Null on
	 * a plain project; absent from an API that does not send it yet.
	 */
	closeStatus?: CloseStatus | null;
	/**
	 * How many accounts the sign-off examined (EQ-R-0018-002). 0 is "signed
	 * with no evidence"; null is unknown and is never read as 0.
	 */
	signoffEvidenceAccounts?: number | null;
	/** Cancelled tasks. On a close they are also inside `completedTasks`. */
	canceledTasks?: number;
	/**
	 * `YYYY-MM`: the month a close's period ends in. A quarter and its last
	 * month share it; read the period through `pages/close/period`.
	 */
	period?: string | null;
	/** The exact period of a close, inclusive `YYYY-MM-DD`; absent on an older API. */
	periodStart?: string | null;
	periodEnd?: string | null;
	signedOffAt?: string | null;
	/** Set once the reviewer has reviewed a close that still awaits approval. */
	reviewedAt?: string | null;
}

export interface IProjectPostResponse {
	status: boolean;
}

export interface IParamsGetProjects {
	orderBy: string;
	orderDir: "ASC" | "DESC";
	companies: string[];
	user: string[];
	offset: number;
	limit: number;
	type: number;
	status: string[];
}

export interface IBodyCreateProject {
	name: string;
	recurring: number;
	accounting_period: number;
	startDate: string;
	dueDate: string;
	company: number;
	users: number[];
	status: number;
}

export enum ProjectType {
	TEMPLATE = 1,
	BASE = 2,
}

// export enum ProjectRecurring {
//   'Yes' = 1,
//   'No' = 2,
// }

// export enum ProjectRecurringFrequency {
//   'Weekly' = 1,
//   'Monthly' = 2,
//   'Quarterly' = 3,
//   'Yearly' = 4,
// }

export enum ProjectStatus {
	New = 1,
	"In progress" = 2,
	Completed = 3,
	"On hold" = 4,
	Canceled = 5,
}
